import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const OrderSuccessPage = lazy(
  () =>
    import('./OrderSuccessPage.eager').then(mod => ({
      default: mod.OrderSuccessPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
